module.exports = __webpack_public_path__ + "static/CookiePro-a03f701b017673ca6811c0890dfdcf7a.jpg";